import { FunctionComponent } from "react";

import { Typography } from "@digital-services/ui";

interface Props {
  title: string;
}

const SectionTitle: FunctionComponent<Props> = ({ title }) => {
  return (
    <Typography className="mt-10 mb-3" variant="sectionTitle">
      {title}
    </Typography>
  );
};

export default SectionTitle;
